import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../footer";
import Header from "../header";
import { useLanguage } from "context/LanguageContext";

function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, language } = useLanguage();
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const sectionId = location.state?.scrollTo;
        if (sectionId) {
            const el = document.getElementById(sectionId);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    useEffect(() => {
        const script = document.createElement("script");
        script.src = `${process.env.PUBLIC_URL}/assets/js/wow.min.js`;
        script.async = true;

        script.onload = () => {
            if (window.WOW) {
                new window.WOW().init();
            }
        };

        document.body.appendChild(script);
    }, []);
    useEffect(() => {
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);
    useEffect(() => {
        const scrollUp = document.getElementById("scrollUp");
        const circle = document.querySelector(".progress-circle");

        const circumference = 2 * Math.PI * 18;

        const onScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.body.scrollHeight - window.innerHeight;
            const progress = scrollTop / docHeight;
            const offset = circumference * (1 - progress);

            if (circle) circle.style.strokeDashoffset = offset;

            if (scrollTop > 300) {
                scrollUp.classList.add("active");
            } else {
                scrollUp.classList.remove("active");
            }
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // Prevent body scroll when off-canvas is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => { document.body.style.overflow = ""; };
    }, [menuOpen]);

    return (
        <>
            <Header onToggle={() => setMenuOpen((v) => !v)} />

            {/* Off-canvas sidebar */}
            <div className={`off-canvas-wrap${menuOpen ? " show-off-canvas" : ""}`}>
                <div
                    className={`overly${menuOpen ? " show-overly" : ""}`}
                    onClick={() => setMenuOpen(false)}
                ></div>
                <div className="off-canvas-widget">
                    <a
                        href="#"
                        className="off-canvas-close"
                        onClick={(e) => { e.preventDefault(); setMenuOpen(false); }}
                    >
                        <i className="ri-close-line"></i>
                    </a>
                    <div className="off-canvas-menu">
                        <ul className="nav-menu">
                            <li>
                                <a href="#rs-header" onClick={() => setMenuOpen(false)}>{t.home}</a>
                            </li>
                            <li>
                                <a href="#rs-about" onClick={() => setMenuOpen(false)}>{t.about}</a>
                            </li>
                            <li>
                                <a href="#rs-scheme" onClick={() => setMenuOpen(false)}>{t.schemes}</a>
                            </li>
                            <li>
                                <a href="#rs-process" onClick={() => setMenuOpen(false)}>{t.howItWorks}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id="scrollUp">
                <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
                    <path
                        d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"
                        fill="#fff"
                    ></path>
                </svg>
                <svg onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="scrollprogress" width="40" height="40">
                    <circle
                        className="progress-circle"
                        cx="20"
                        cy="20"
                        r="18"
                        strokeWidth="2"
                        fill="none"
                        stroke="#fff"
                        strokeDasharray="113.1"
                        strokeDashoffset="113.1"
                    ></circle>
                </svg>
            </div>

            {/* Banner */}
            <section className={`rs-banner pt-100 rs-banner-top ${language === 'ML' ? 'pb-200' : 'pb-140'}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-xl-7">
                            <div className="rs-banner__content">
                                <h1 className="title" style={language === 'ML' ? { fontSize: '42px', lineHeight: '54px' } : {}}>{t.bannerTitle}</h1>
                                {t.bannerTagline ? (
                                    <p className="banner-tagline">{t.bannerTagline}</p>
                                ) : null}
                                <p>{t.bannerSubtitle}</p>
                                <a className="main-btn" href="#rs-about">
                                    {t.readMore} <i className="ri-arrow-right-line"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* About service cards */}
            <div className="rs-about-service">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="rs-about-service__item">
                                <div className="rs-content pe-5">
                                    <h4 className="title">{t.riskFundBeneficiaries}</h4>
                                    <p>{t.riskFundBeneficiariesDesc}</p>
                                    <button className="main-btn border-0 mt-2" type="button" onClick={() => {
                                        const token = sessionStorage.getItem("jwt");
                                        navigate(token ? "/userDashboard" : "/login");
                                    }}>
                                        {t.applyForClaim} <i className="ri-arrow-right-up-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="rs-about-service__item item-2">
                                <div className="rs-content">
                                    <h4 className="title">{t.societiesAndBanks}</h4>
                                    <p>{t.societiesAndBanksDesc}</p>
                                    <button className="main-btn border-0 mt-2" type="submit"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate("/register");
                                        }}>
                                        {t.registerSociety} <i className="ri-arrow-right-up-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* About section */}
            <section className="rs-about pt-120" id="rs-about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div
                                className="rs-about__thumb wow fadeInLeft pe-5"
                                data-wow-duration="1.5s"
                                data-wow-delay="0s"
                            >
                                <img src={`${process.env.PUBLIC_URL}/assets/images/About-RWFMS.png`} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="rs-about__content">
                                <span>{t.aboutUsLabel}</span>
                                <h2 className="title">{t.aboutRWFMS}</h2>
                                <p>{t.aboutDesc}</p>
                            </div>
                            <div className="rs-counter-2 about-counter-1">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div
                                            className="rs-counter-2__item mt-40 wow fadeInLeft"
                                            data-wow-duration="1.5s"
                                            data-wow-delay="0s"
                                        >
                                            <div className="rs-content">
                                                <h4 className="title">{t.digitalProcessing}</h4>
                                                <p>{t.digitalProcessingDesc}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div
                                            className="rs-counter-2__item mt-40 wow fadeInRight"
                                            data-wow-duration="1.5s"
                                            data-wow-delay="0.0s"
                                        >
                                            <div className="rs-content">
                                                <h4 className="title">{t.transparentGovernance}</h4>
                                                <p>{t.transparentGovernanceDesc}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div
                                            className="rs-counter-2__item mt-40 wow fadeInLeft"
                                            data-wow-duration="1.5s"
                                            data-wow-delay="0.0s"
                                        >
                                            <div className="rs-content">
                                                <h4 className="title">{t.swiftDisbursement}</h4>
                                                <p>{t.swiftDisbursementDesc}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Risk Fund Schemes */}
            <section className="rs-why-choose-about-page pt-120 pb-145" id="rs-scheme">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="section-title">
                                <span>{t.schemesCovered}</span>
                                <h2 className="title">{t.riskFundSchemes}</h2>
                                <p>{t.riskFundSchemesDesc}</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="rs-why-choose-about-page__thumb">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/Risk-Fund-Schemes-RWFMS.png`} alt="" />
                                <div className="rs-shape"></div>
                            </div>
                        </div>
                    </div>
                    <div className="rs-why-choose-box" style={language === 'ML' ? { marginTop: 0 } : {}}>
                        <div className="row">
                            <div className="col-lg-11">
                                <div className="row pr-85">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="rs-why-choose-about-page__item">
                                            <span>01</span>
                                            <h4 className="title">{t.deathClaimSupport}</h4>
                                            <p>{t.deathClaimDesc}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="rs-why-choose-about-page__item">
                                            <span>02</span>
                                            <h4 className="title">{t.treatmentClaimSupport}</h4>
                                            <p>{t.treatmentClaimDesc}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Welfare Fund Schemes */}
            <section className="rs-why-choose-about-page pb-145">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 order-lg-0 order-1">
                            <div className="rs-why-choose-about-page__thumb">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/images/Welfare-Fund-Schemes-RWFMS.png`}
                                    alt=""
                                />
                                <div className="rs-shape"></div>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-0">
                            <div className="section-title">
                                <span>{t.schemesCovered}</span>
                                <h2 className="title">{t.welfareFundSchemes}</h2>
                                <p>{t.welfareFundSchemesDesc}</p>
                            </div>
                        </div>
                    </div>
                    <div className="rs-why-choose-box" style={language === 'ML' ? { marginTop: 0 } : {}}>
                        <div className="row">
                            <div className="col-lg-1"></div>
                            <div className="col-lg-11">
                                <div className="row pr-85">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="rs-why-choose-about-page__item">
                                            <span>01</span>
                                            <h4 className="title">{t.societyEnrollment}</h4>
                                            <p>{t.societyEnrollmentDesc}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="rs-why-choose-about-page__item">
                                            <span>02</span>
                                            <h4 className="title">{t.annualRenewal}</h4>
                                            <p>{t.annualRenewalDesc}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How it Works */}
            <section className="rs-work-progress pt-120 pb-120" id="rs-process">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            <div className="section-title">
                                <span>{t.howItWorksLabel}</span>
                                <h2 className="title">{t.easySteps}</h2>
                            </div>
                        </div>
                        <div className="col-lg-2"></div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="rs-work-progress__item wow fadeInUp pr-54"
                                data-wow-duration="1s"
                                data-wow-delay="0s"
                            >
                                <div className="rs-top-inner">
                                    <div className="rs-number"><span>01</span></div>
                                    <div className="rs-title">
                                        <h3 className="title">{t.register}</h3>
                                    </div>
                                </div>
                                <div className="rs-text">
                                    <p>{t.registerDesc}</p>
                                </div>
                                <div className="rs-arrow">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/arrow-directions.svg`} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="rs-work-progress__item wow fadeInUp pr-54"
                                data-wow-duration="1s"
                                data-wow-delay=".3s"
                            >
                                <div className="rs-top-inner">
                                    <div className="rs-number"><span>02</span></div>
                                    <div className="rs-title">
                                        <h3 className="title">{t.submitClaim}</h3>
                                    </div>
                                </div>
                                <div className="rs-text">
                                    <p>{t.submitClaimDesc}</p>
                                </div>
                                <div className="rs-arrow">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/arrow-directions.svg`} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="rs-work-progress__item wow fadeInUp item-2 pl-95"
                                data-wow-duration="1s"
                                data-wow-delay="0.6s"
                            >
                                <div className="rs-top-inner">
                                    <div className="rs-number"><span>03</span></div>
                                    <div className="rs-title">
                                        <h3 className="title">{t.verification}</h3>
                                    </div>
                                </div>
                                <div className="rs-text">
                                    <p>{t.verificationDesc}</p>
                                </div>
                                <div className="rs-arrow">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/arrow-directions.svg`} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="rs-work-progress__item wow fadeInUp item-3 pl-95"
                                data-wow-duration="1s"
                                data-wow-delay="0.6s"
                            >
                                <div className="rs-top-inner">
                                    <div className="rs-number"><span>04</span></div>
                                    <div className="rs-title">
                                        <h3 className="title">{t.disbursement}</h3>
                                    </div>
                                </div>
                                <div className="rs-text">
                                    <p>{t.disbursementDesc}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default Home;
